export default __webpack_public_path__ + "static/media/Loading.6e67c068.gif";